import React from 'react'
import { Button } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons';

class TimeTrackingHeader extends React.Component {

    render = () => {
        this.props.info('TimeTrackingHeader.js/render');
        return (

            <tr>
                <th width="26%">Date / User</th>
                <th width="19%">Actual Start</th>
                <th width="19%">Actual End</th>
                <th width="19%">Actual Total Hours</th>
                <th width="17%">
                    {this.props.addTaskTimeTrackingId === 0 && this.props.addWorkflowId === 0 &&
                        <Button
                            color="primary"
                            className="mr-4"
                            onClick={(e) => {
                                e.stopPropagation(); this.props.cb({
                                    addTaskTimeTrackingId: this.props.taskId,
                                    addWorkflowId: this.props.workflowId
                                })
                            }}>
                            <FontAwesomeIcon icon={faPlus} />
                        </Button>}
                </th>
            </tr>

        )
    }
}

export default TimeTrackingHeader;